import { Fetch } from '../../shared/types';
import { ZapierProfile } from '@zapier/universal-layout';

interface ResponseData {
  results: {
    id: number;
    name: string;
    logo_url: string;
    is_team_account?: boolean;
  }[];
}

export const getAccounts = async (fetch: Fetch): Promise<ZapierProfile[]> =>
  (await fetch<ResponseData>('/api/v4/accounts/')).results.map(
    ({ id, is_team_account, logo_url, name, ...rest }) => ({
      ...rest,
      id,
      isTeamAccount: is_team_account,
      normalizedImageUrl: logo_url,
      normalizedName: name,
    })
  );

export default getAccounts;
